import { render, staticRenderFns } from "./publish-list.vue?vue&type=template&id=42f7477a&scoped=true"
import script from "./publish-list.vue?vue&type=script&lang=js"
export * from "./publish-list.vue?vue&type=script&lang=js"
import style0 from "./publish-list.vue?vue&type=style&index=0&id=42f7477a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f7477a",
  null
  
)

export default component.exports